/**
 * TUVI - Topbar Navigation
 * Menú horizontal superior con dropdowns hover (mega-menu) por categoría.
 * Layout: [LOGO] ... [Menús centrados con hover] ... [Usuario + Salir]
 * En móvil: hamburguesa que abre panel vertical con los menús.
 */

import React, { useMemo, useState, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import './Sidebar.css';

// Estructura completa del menú (sin roles, los permisos se manejan por usuario)
export const MENU_STRUCTURE = [
  {
    id: 'proyectos',
    name: 'Proyectos',
    submenu: [
      { id: 'lista-proyectos', name: 'Lista de Proyectos' },
      { id: 'lista-exportar', name: 'Lista de Proyectos - Exportar Excel', hidden: true },
      { id: 'proyectos-especiales', name: 'Proyectos Especiales' },
      { id: 'proyectos-liquidados', name: 'Entregados y Liquidados' },
      { id: 'polizas', name: 'Pólizas' },
      { id: 'edicion-cronograma', name: 'Edición de Cronograma', hidden: true },
      { id: 'cronograma-general', name: 'Cronograma General' },
      { id: 'mis-compromisos', name: 'Mis Compromisos' },
      { id: 'bitacora-crear', name: 'Novedades - Crear, editar y eliminar compromisos', hidden: true },
      { id: 'ffe-anular-recepcion', name: 'Ficha FFE - Anular aceptación del material', hidden: true },
      { id: 'facturas', name: 'Facturas' },
      { id: 'posventa', name: 'Posventa' },
      { id: 'caja-menor', name: 'Caja Menor' },
      { id: 'caja-menor-administrativo', name: 'Caja Menor - Administrativo' },
      { id: 'caja-menor-ingenieros', name: 'Caja Menor - Ingenieros', hidden: true },
      { id: 'caja-menor-crear-entrega', name: 'Caja Menor - Crear Entrega', hidden: true },
      { id: 'caja-menor-eliminar-entrega', name: 'Caja Menor - Eliminar Entrega', hidden: true },
      { id: 'caja-menor-comprobantes', name: 'Caja Menor - Comprobantes', hidden: true },
      { id: 'caja-menor-aprobaciones', name: 'Caja Menor - Aprobaciones', hidden: true }
    ]
  },
  {
    id: 'proveedores',
    name: 'Proveedores',
    submenu: [
      { id: 'proveedores', name: 'Gestión' },
      { id: 'pagos', name: 'Pagos' },
      { id: 'tipos-proveedor', name: 'Tipos de Proveedores' }
    ]
  },
  {
    id: 'bodega',
    name: 'Bodega',
    submenu: [
      { id: 'inventario-bodega', name: 'Inventario' },
      { id: 'entradas-bodega', name: 'Entradas' },
      { id: 'salidas-bodega', name: 'Salidas' }
    ]
  },
  {
    id: 'administrativo',
    name: 'Administrativo',
    submenu: [
      { id: 'cartera', name: 'Cartera' },
      { id: 'facturas-admin', name: 'Facturas' },
      { id: 'residentes', name: 'Residentes' },
      { id: 'enchapes', name: 'Enchapes' },
      { id: 'conceptos-facturas', name: 'Conceptos Facturas' },
      { id: 'alertas', name: 'Alertas y Correos' }
    ]
  },
  {
    id: 'documentos',
    name: 'Documentos',
    submenu: [
      { id: 'cuentas-cobro', name: 'Cuentas de Cobro' },
      { id: 'cuentas-cobro-confirmar', name: 'Cuentas de Cobro - Validar Pago', hidden: true },
      { id: 'contratos', name: 'Contratos' },
      { id: 'contratos-editar-plantilla', name: 'Contratos - Editar Plantilla', hidden: true },
      { id: 'matriz-actividades', name: 'Matriz Actividades' },
      { id: 'matriz-aprobar', name: 'Matriz - Aprobar actividades nuevas', hidden: true },
      { id: 'cotizaciones', name: 'Cotizador' },
      { id: 'cotizaciones-incremento', name: 'Cotizador - Ver Incremento Actividades', hidden: true },
      { id: 'cotizaciones-descuento', name: 'Cotizador - Descuento mayor al 3%', hidden: true },
      { id: 'cotizaciones-aprobacion-comercial', name: 'Cotizador - Aprobación comercial de Bases', hidden: true },
      { id: 'cotizaciones-aprobacion-tecnica', name: 'Cotizador - Aprobación técnica de Bases', hidden: true },
      { id: 'cotizaciones-valor-unitario', name: 'Cotizador - Editar valor unitario', hidden: true },
      { id: 'cotizaciones-bloquear', name: 'Cotizador - Bloquear actividades', hidden: true },
      { id: 'cotizaciones-incremento-defecto', name: 'Cotizador - Editar incremento por defecto', hidden: true },
      { id: 'ficha-ffe', name: 'Ficha FFE' },
      { id: 'ffe-tab-ficha', name: 'FFE - Pestaña Ficha', hidden: true },
      { id: 'ffe-tab-contratistas', name: 'FFE - Pestaña Contratistas', hidden: true },
      { id: 'ffe-tab-carrito', name: 'FFE - Pestaña Carrito', hidden: true },
      { id: 'ffe-editar-comercial', name: 'FFE - Editar Comercial', hidden: true },
      { id: 'carrito-compras-general', name: 'Carrito de Compras General' },
      { id: 'planos', name: 'Planos' },
      { id: 'formulas-carrito', name: 'Formulas Carrito' },
      { id: 'catalogo-ffe', name: 'Catalogo FFE' },
      { id: 'catalogo-tienda-editar', name: 'Catálogo Tienda - Editar productos y categorías', hidden: true },
      { id: 'contabilidad', name: 'Contabilidad' }
    ]
  },
  {
    id: 'informes',
    name: 'Informes Comerciales',
    submenu: [
      { id: 'informe-cotizaciones', name: 'Cotizaciones' },
      { id: 'informe-fichaffe', name: 'Ficha FFE' }
    ]
  },
  {
    id: 'crm-gestion',
    name: 'CRM Comercial',
    // Sin submenu — clickeable directo
  },
  {
    id: 'gerencia',
    name: 'Gerencia',
    submenu: [
      { id: 'tablero-gerencial', name: 'Tablero' },
      { id: 'seguimiento-comercial', name: 'Seguimiento Comercial' },
      { id: 'marketing', name: 'Marketing' },
      { id: 'tecnico', name: 'Técnico' },
      { id: 'vista-financiera', name: 'Vista Financiera' },
      { id: 'vista-financiera-caja', name: 'Vista Financiera - Editar Caja', hidden: true }
    ]
  },
  {
    id: 'acceso',
    name: 'Acceso',
    submenu: [
      { id: 'usuarios', name: 'Usuarios' }
    ]
  }
];

// Cuantos items por columna en el mega-menu. Si un menu tiene mas, se hace multi-col.
const COLS_THRESHOLD = 6;

const Sidebar = ({ activeModule, onModuleChange, isOpen, onClose, user, onLogout }) => {
  const { user: authUser } = useAuth();
  const u = user || authUser;
  const userPermisos = u?.permisos || {};

  // Filtrar menús según permisos del usuario (excluir items hidden).
  // Los menús sin submenu (p.ej. CRM Comercial) se gatean por su permiso
  // directo: userPermisos[menu.id].
  const menuItems = useMemo(() => {
    return MENU_STRUCTURE
      .map(menu => {
        if (!menu.submenu) return menu;
        return {
          ...menu,
          submenu: menu.submenu.filter(sub => {
            if (sub.hidden) return false;
            const key = `${menu.id}.${sub.id}`;
            return !!userPermisos[key];
          })
        };
      })
      .filter(menu => menu.submenu ? menu.submenu.length > 0 : !!userPermisos[menu.id]);
  }, [userPermisos]);

  // Detecta si un subitem esta activo en este menu (para resaltar el principal)
  const menuActiveStates = useMemo(() => {
    const map = {};
    for (const m of menuItems) {
      if (!m.submenu) { map[m.id] = activeModule === m.id; continue; }
      map[m.id] = m.submenu.some(s => s.id === activeModule);
    }
    return map;
  }, [menuItems, activeModule]);

  // Partir submenu en columnas (mega-menu) cuando son muchos
  const splitIntoCols = (items) => {
    if (items.length <= COLS_THRESHOLD) return [items];
    const half = Math.ceil(items.length / 2);
    return [items.slice(0, half), items.slice(half)];
  };

  const handleSubClick = (id) => {
    onModuleChange(id);
    if (onClose) onClose();
  };

  // Control manual del dropdown abierto: hover lo abre, click lo cierra.
  // Usamos timeout corto al salir para que el cursor pueda viajar del menu
  // al dropdown sin perder el hover.
  const [openMenu, setOpenMenu] = useState(null);
  const closeTimerRef = useRef(null);

  const openDropdown = (id) => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setOpenMenu(id);
  };
  const scheduleClose = () => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    closeTimerRef.current = setTimeout(() => setOpenMenu(null), 120);
  };
  const closeNow = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setOpenMenu(null);
  };

  const handleTopClick = (item) => {
    if (item.submenu) {
      closeNow(); // click en menu padre tambien cierra (toggle off si ya estaba abierto)
    } else {
      onModuleChange(item.id);
      closeNow();
    }
  };

  const handleDropdownItemClick = (id) => {
    onModuleChange(id);
    closeNow();
  };

  return (
    <>
      <header className={`topbar ${isOpen ? 'mobile-open' : ''}`}>
        {/* Logo a la izquierda */}
        <div className="topbar-logo">
          <img src="/logo.png" alt="TUVI Logo" className="logo-full" />
        </div>

        {/* Navegacion centrada (desktop) */}
        <nav className="topbar-nav">
          {menuItems.map(item => {
            const isActive = menuActiveStates[item.id];
            const hasSub = !!item.submenu;
            const isOpenNow = hasSub && openMenu === item.id;
            return (
              <div
                key={item.id}
                className={`topbar-menu-item ${isActive ? 'active' : ''} ${hasSub ? 'has-sub' : ''} ${isOpenNow ? 'is-open' : ''}`}
                onMouseEnter={() => hasSub && openDropdown(item.id)}
                onMouseLeave={() => hasSub && scheduleClose()}
              >
                <button
                  className="topbar-menu-btn"
                  onClick={() => handleTopClick(item)}
                  type="button"
                >
                  <span className="topbar-menu-name">{item.name}</span>
                  {hasSub && <span className="topbar-menu-arrow">▾</span>}
                </button>

                {hasSub && (
                  <div className={`topbar-dropdown ${item.submenu.length > COLS_THRESHOLD ? 'mega' : ''}`}>
                    <div className="topbar-dropdown-inner">
                      {splitIntoCols(item.submenu).map((col, ci) => (
                        <ul key={ci} className="topbar-dropdown-col">
                          {col.map(sub => (
                            <li key={sub.id}>
                              <button
                                type="button"
                                className={`topbar-dropdown-item ${activeModule === sub.id ? 'active' : ''}`}
                                onClick={() => handleDropdownItemClick(sub.id)}
                              >
                                {sub.name}
                              </button>
                            </li>
                          ))}
                        </ul>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        {/* Usuario y logout a la derecha */}
        <div className="topbar-user">
          <div className="topbar-user-info">
            <div className="topbar-avatar" title={u?.username || ''}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
            </div>
            <div className="topbar-user-text">
              <span className="topbar-user-name">{u?.nombre || u?.username || 'Usuario'}</span>
              <span className="topbar-user-role">{u?.rol === 'admin' ? 'Administrador' : 'Usuario'}</span>
            </div>
          </div>
          {onLogout && (
            <button className="topbar-logout-btn" onClick={onLogout} title="Cerrar sesión" type="button">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                <polyline points="16 17 21 12 16 7"/>
                <line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
              <span className="topbar-logout-text">Salir</span>
            </button>
          )}
        </div>
      </header>

      {/* Panel lateral movil (solo se abre desde el hamburguesa) */}
      {isOpen && (
        <aside className="topbar-mobile-panel">
          <button className="topbar-mobile-close" onClick={onClose} type="button" aria-label="Cerrar">✕</button>
          <nav className="topbar-mobile-nav">
            {menuItems.map(item => {
              const hasSub = !!item.submenu;
              return (
                <details key={item.id} className="topbar-mobile-group" open={menuActiveStates[item.id]}>
                  <summary className="topbar-mobile-summary">
                    {item.name}
                    {hasSub && <span className="topbar-menu-arrow">▾</span>}
                  </summary>
                  {hasSub ? (
                    <ul className="topbar-mobile-sub">
                      {item.submenu.map(sub => (
                        <li key={sub.id}>
                          <button
                            type="button"
                            className={`topbar-mobile-subitem ${activeModule === sub.id ? 'active' : ''}`}
                            onClick={() => handleSubClick(sub.id)}
                          >
                            {sub.name}
                          </button>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <button
                      type="button"
                      className={`topbar-mobile-subitem ${activeModule === item.id ? 'active' : ''}`}
                      onClick={() => handleSubClick(item.id)}
                    >
                      Abrir
                    </button>
                  )}
                </details>
              );
            })}
          </nav>
        </aside>
      )}
    </>
  );
};

export default Sidebar;
